<script lang="ts">
    import type {DatetimeRangeFilterableDatatype, GenericDatatypedFilterDefinition} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<DatetimeRangeFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}/>